import React from 'react';
import '../../tailwind.css';
import { IExportButtonContainer } from '../../types/ExportButtonContainer.types';

const ExportButtonContainer: React.FC<IExportButtonContainer> = (props) => {
  return (
    <div className="flex justify-center">
      <div className="relative flex max-w-app-column w-full py-12px pl-safe-area-l pr-safe-area-r justify-center">
        {props.children}
      </div>
    </div>
  )
};

export default ExportButtonContainer;